export const enPlayerRoles: { [key: string]: string } = {
  'baserole.shortHand.GOAL_KEEPER': 'GK',
  'baserole.shortHand.CENTER_BACK': 'CB',
  'baserole.shortHand.FULL_BACK': 'FB',
  'baserole.shortHand.DEFENSIVE_MIDFIELDER': 'DM',
  'baserole.shortHand.CENTRAL_MIDFIELDER': 'CM',
  'baserole.shortHand.ATTACKING_MIDFIELDER': 'AM',
  'baserole.shortHand.WIDE_MIDFIELDER': 'WM',
  'baserole.shortHand.WINGER': 'W',
  'baserole.shortHand.STRIKER': 'ST',
  'playerroles.bonuses': 'Bonuses',
  'playerroles.traits': 'Traits',

  // --- Base Roles ---
  'playerroles.GOAL_KEEPER': 'Goalkeeper',
  'playerroles.FULL_BACK': 'Full Back',
  'playerroles.CENTER_BACK': 'Center Back',
  'playerroles.DEFENSIVE_MIDFIELDER': 'Defensive Midfielder',
  'playerroles.WIDE_MIDFIELDER': 'Wide Midfielder',
  'playerroles.CENTRAL_MIDFIELDER': 'Central Midfielder',
  'playerroles.ATTACKING_MIDFIELDER': 'Attacking Midfielder',
  'playerroles.WINGER': 'Winger',
  'playerroles.STRIKER': 'Striker',

  // --- Goalkeeper Expanded Roles ---
  'playerroles.DETERMINED_GOALKEEPER': 'Determined Goalkeeper',
  'playerroles.HEROIC_GOALKEEPER': 'Heroic Goalkeeper',
  'playerroles.ECCENTRIC_GOALKEEPER': 'Eccentric Goalkeeper',
  'playerroles.RELIABLE_GOALKEEPER': 'Reliable Goalkeeper',
  'playerroles.LUCKY_GOALKEEPER': 'Lucky Goalkeeper',
  'playerroles.TENACIOUS_GOALKEEPER': 'Tenacious Goalkeeper',
  'playerroles.INSPIRATIONAL_GOALKEEPER': 'Inspirational Goalkeeper',
  'playerroles.DOMINANT_GOALKEEPER': 'Dominant Goalkeeper',
  'playerroles.IMPACT_GOALKEEPER': 'Impact Goalkeeper',
  'playerroles.STUBBORN_GOALKEEPER': 'Stubborn Goalkeeper',
  'playerroles.ORGANISED_GOALKEEPER': 'Organised Goalkeeper',
  'playerroles.NO_NONSENSE_GOALKEEPER': 'No Nonsense Goalkeeper',
  'playerroles.BALL_PLAYING_GOALKEEPER': 'Ball Playing Goalkeeper',
  'playerroles.SWEEPER_KEEPER': 'Sweeper Keeper',
  'playerroles.COMPLETE_GOALKEEPER': 'Complete Goalkeeper',
  'playerroles.PLUCKY_GOALKEEPER': 'Plucky Goalkeeper',
  'playerroles.VALIANT_GOALKEEPER': 'Valiant Goalkeeper',
  'playerroles.IMPOSING_GOALKEEPER': 'Imposing Goalkeeper',
  'playerroles.WALL': 'Wall',
  'playerroles.COMMANDING_KEEPER': 'Commanding Keeper',
  'playerroles.PLAYMAKING_GOALKEEPER': 'Playmaking Goalkeeper',
  'playerroles.MODERN_GOALKEEPER': 'Modern Goalkeeper',
  'playerroles.ROUSING_GOALKEEPER': 'Rousing Goalkeeper',

  // --- Full Back Expanded Roles ---
  'playerroles.RAPID_FULL_BACK': 'Rapid Full Back',
  'playerroles.POWERFUL_FULL_BACK': 'Powerful Full Back',
  'playerroles.TIRELESS_FULL_BACK': 'Tireless Full Back',
  'playerroles.DETERMINED_FULL_BACK': 'Determined Full Back',
  'playerroles.HEROIC_FULL_BACK': 'Heroic Full Back',
  'playerroles.ECCENTRIC_FULL_BACK': 'Eccentric Full Back',
  'playerroles.RELIABLE_FULL_BACK': 'Reliable Full Back',
  'playerroles.LUCKY_FULL_BACK': 'Lucky Full Back',
  'playerroles.TENACIOUS_FULL_BACK': 'Tenacious Full Back',
  'playerroles.INSPIRATIONAL_FULL_BACK': 'Inspirational Full Back',
  'playerroles.DOMINANT_FULL_BACK': 'Dominant Full Back',
  'playerroles.IMPACT_FULL_BACK': 'Impact Full Back',
  'playerroles.PRESSING_FULL_BACK': 'Pressing Full Back',
  'playerroles.RETENTIVE_FULL_BACK': 'Retentive Full Back',
  'playerroles.STUBBORN_FULL_BACK': 'Stubborn Full Back',
  'playerroles.SHIELDING_FULL_BACK': 'Shielding Full Back',
  'playerroles.VOCAL_FULL_BACK': 'Vocal Full Back',
  'playerroles.EXPERIENCED_FULL_BACK': 'Experienced Full Back',
  'playerroles.MARAUDING_FULL_BACK': 'Marauding Full Back',
  'playerroles.WING_BACK': 'Wing Back',
  'playerroles.ORCHESTRATING_FULL_BACK': 'Orchestrating Full Back',
  'playerroles.SILKY_FULL_BACK': 'Silky Full Back',
  'playerroles.STAR_FULL_BACK': 'Star Full Back',
  'playerroles.ROAMING_FULL_BACK': 'Roaming Full Back',
  'playerroles.EXPERT_FULL_BACK': 'Expert Full Back',
  'playerroles.COVERING_FULL_BACK': 'Covering Full Back',
  'playerroles.NO_NONSENSE_FULL_BACK': 'No Nonsense Full Back',
  'playerroles.ATHLETIC_FULL_BACK': 'Athletic Full Back',
  'playerroles.ENERGETIC_FULL_BACK': 'Energetic Full Back',
  'playerroles.VALIANT_FULL_BACK': 'Valiant Full Back',
  'playerroles.PLUCKY_FULL_BACK': 'Plucky Full Back',
  'playerroles.ROBUST_FULL_BACK': 'Robust Full Back',
  'playerroles.AGGRESSIVE_FULL_BACK': 'Aggressive Full Back',
  'playerroles.COMMANDING_FULL_BACK': 'Commanding Full Back',
  'playerroles.RAPID_WING_BACK': 'Rapid Wing Back',
  'playerroles.ATTACKING_WING_BACK': 'Attacking Wing Back',
  'playerroles.SOLID_DEFENDER': 'Solid Defender',
  'playerroles.TRADITIONAL_FULL_BACK': 'Traditional Full Back',
  'playerroles.COMPLETE_FULL_BACK': 'Complete Full Back',
  'playerroles.INVERTED_FULL_BACK': 'Inverted Full Back',
  'playerroles.LAST_DITCH_DEFENDER': 'Last Ditch Defender',
  'playerroles.FIREY_FULL_BACK': 'Firey Full Back',
  'playerroles.VERSATILE_FULL_BACK': 'Versatile Full Back',
  'playerroles.ROUSING_FULL_BACK': 'Rousing Full Back',

  // --- Center Back Expanded Roles ---
  'playerroles.RAPID_CENTER_BACK': 'Rapid Center Back',
  'playerroles.POWERFUL_CENTER_BACK': 'Powerful Center Back',
  'playerroles.TIRELESS_CENTER_BACK': 'Tireless Center Back',
  'playerroles.DETERMINED_CENTER_BACK': 'Determined Center Back',
  'playerroles.HEROIC_CENTER_BACK': 'Heroic Center Back',
  'playerroles.RELIABLE_CENTER_BACK': 'Reliable Center Back',
  'playerroles.LUCKY_CENTER_BACK': 'Lucky Center Back',
  'playerroles.TENACIOUS_CENTER_BACK': 'Tenacious Center Back',
  'playerroles.INSPIRATIONAL_CENTER_BACK': 'Inspirational Center Back',
  'playerroles.DOMINANT_CENTER_BACK': 'Dominant Center Back',
  'playerroles.IMPACT_CENTER_BACK': 'Impact Center Back',
  'playerroles.STUBBORN_CENTER_BACK': 'Stubborn Center Back',
  'playerroles.VOCAL_CENTER_BACK': 'Vocal Center Back',
  'playerroles.RETENTIVE_CENTER_BACK': 'Retentive Center Back',
  'playerroles.NO_NONSENSE_CENTER_BACK': 'No Nonsense Center Back',
  'playerroles.MAN_MARKING': 'Man Marking',
  'playerroles.SWEEPER': 'Sweeper',
  'playerroles.COVERING_CENTER_BACK': 'Covering Center Back',
  'playerroles.EXPERT_CENTER_BACK': 'Expert Center Back',
  'playerroles.ORCHESTRATING_CENTER_BACK': 'Orchestrating Center Back',
  'playerroles.EXPERIENCED_CENTER_BACK': 'Experienced Center Back',
  'playerroles.ATHLETIC_CENTER_BACK': 'Athletic Center Back',
  'playerroles.ROBUST_CENTER_BACK': 'Robust Center Back',
  'playerroles.AGGRESSIVE_CENTER_BACK': 'Aggressive Center Back',
  'playerroles.ENERGETIC_CENTER_BACK': 'Energetic Center Back',
  'playerroles.VALIANT_CENTER_BACK': 'Valiant Center Back',
  'playerroles.PLUCKY_CENTER_BACK': 'Plucky Center Back',
  'playerroles.COMMANDING_CENTERBACK': 'Commanding Centerback',
  'playerroles.BALL_PLAYING_DEFENDER': 'Ball Playing Defender',
  'playerroles.TECHNICAL_DEFENDER': 'Technical Defender',
  'playerroles.LIBERO': 'Libero',
  'playerroles.ROCK': 'Rock',
  'playerroles.RESOLUTE_CENTER_BACK': 'Resolute Center Back',
  'playerroles.IMPOSING_DEFENDER': 'Imposing Defender', // Key from enum is IMPOSING_DEFENDER
  'playerroles.TRADITIONAL_CENTER_BACK': 'Traditional Center Back',
  'playerroles.LOCKDOWN_DEFENDER': 'Lockdown Defender',
  'playerroles.MODERN_CENTER_BACK': 'Modern Center Back',
  'playerroles.WARRIOR': 'Warrior',
  'playerroles.FIREY_CENTER_BACK': 'Firey Center Back',
  'playerroles.VERSATILE_CENTER_BACK': 'Versatile Center Back',
  'playerroles.COMPOSED_DEFENDER': 'Composed Defender',
  'playerroles.ROUSING_DEFENDER': 'Rousing Defender',

  // --- Defensive Midfielder Expanded Roles ---
  'playerroles.RAPID_DEFENSIVE_MIDFIELDER': 'Rapid Defensive Midfielder',
  'playerroles.POWERFUL_DEFENSIVE_MIDFIELDER': 'Powerful Defensive Midfielder',
  'playerroles.TIRELESS_DEFENSIVE_MIDFIELDER': 'Tireless Defensive Midfielder',
  'playerroles.DETERMINED_DEFENSIVE_MIDFIELDER':
    'Determined Defensive Midfielder',
  'playerroles.HEROIC_DEFENSIVE_MIDFIELDER': 'Heroic Defensive Midfielder',
  'playerroles.ECCENTRIC_DEFENSIVE_MIDFIELDER':
    'Eccentric Defensive Midfielder',
  'playerroles.RELIABLE_DEFENSIVE_MIDFIELDER': 'Reliable Defensive Midfielder',
  'playerroles.LUCKY_DEFENSIVE_MIDFIELDER': 'Lucky Defensive Midfielder',
  'playerroles.TENACIOUS_DEFENSIVE_MIDFIELDER':
    'Tenacious Defensive Midfielder',
  'playerroles.INSPIRATIONAL_DEFENSIVE_MIDFIELDER':
    'Inspirational Defensive Midfielder',
  'playerroles.DOMINANT_DEFENSIVE_MIDFIELDER': 'Dominant Defensive Midfielder',
  'playerroles.IMPACT_DEFENSIVE_MIDFIELDER': 'Impact Defensive Midfielder',
  'playerroles.PRESSING_DEFENSIVE_MIDFIELDER': 'Pressing Defensive Midfielder',
  'playerroles.STUBBORN_DEFENSIVE_MIDFIELDER': 'Stubborn Defensive Midfielder',
  'playerroles.VOCAL_DEFENSIVE_MIDFIELDER': 'Vocal Defensive Midfielder',
  'playerroles.RETENTIVE_DEFENSIVE_MIDFIELDER':
    'Retentive Defensive Midfielder',
  'playerroles.EXPERIENCED_DEFENSIVE_MIDFIELDER':
    'Experienced Defensive Midfielder',
  'playerroles.DEEP_LYING_PLAYMAKER': 'Deep Lying Playmaker',
  'playerroles.SECURE_DEFENSIVE_MIDFIELDER': 'Secure Defensive Midfielder',
  'playerroles.SHIELDING_DEFENSIVE_MIDFIELDER':
    'Shielding Defensive Midfielder',
  'playerroles.ORCHESTRATING_DEFENSIVE_MIDFIELDER':
    'Orchestrating Defensive Midfielder',
  'playerroles.SILKY_DEFENSIVE_MIDFIELDER': 'Silky Defensive Midfielder',
  'playerroles.STAR_DEFENSIVE_MIDFIELDER': 'Star Defensive Midfielder',
  'playerroles.ATHLETIC_DEFENSIVE_MIDFIELDER': 'Athletic Defensive Midfielder',
  'playerroles.ENERGETIC_DEFENSIVE_MIDFIELDER':
    'Energetic Defensive Midfielder',
  'playerroles.VALIANT_DEFENSIVE_MIDFIELDER': 'Valiant Defensive Midfielder',
  'playerroles.PLUCKY_DEFENSIVE_MIDFIELDER': 'Plucky Defensive Midfielder',
  'playerroles.ROBUST_DEFENSIVE_MIDFIELDER': 'Robust Defensive Midfielder',
  'playerroles.AGGRESSIVE_DEFENSIVE_MIDFIELDER':
    'Aggressive Defensive Midfielder',
  'playerroles.GEGENPRESSING_DEFENSIVE_MIDFIELDER':
    'Gegenpressing Defensive Midfielder',
  'playerroles.COMMANDING_DEFENSIVE_MIDFIELDER':
    'Commanding Defensive Midfielder',
  'playerroles.REGISTA': 'Regista',
  'playerroles.BALL_WINNING_MIDFIELDER': 'Ball Winning Midfielder',
  'playerroles.ANCHOR': 'Anchor',
  'playerroles.COMMANDING_ANCHOR': 'Commanding Anchor',
  'playerroles.DESTROYER': 'Destroyer',
  'playerroles.SPACE_EATER': 'Space Eater',
  'playerroles.FIREY_DEFENSIVE_MIDFIELDER': 'Firey Defensive Midfielder',
  'playerroles.VERSATILE_DEFENSIVE_MIDFIELDER':
    'Versatile Defensive Midfielder',
  'playerroles.ROUSING_DEFENSIVE_MIDFIELDER': 'Rousing Defensive Midfielder',

  // --- Wide Midfielder Expanded Roles ---
  'playerroles.RAPID_WIDE_MIDFIELDER': 'Rapid Wide Midfielder',
  'playerroles.POWERFUL_WIDE_MIDFIELDER': 'Powerful Wide Midfielder',
  'playerroles.TIRELESS_WIDE_MIDFIELDER': 'Tireless Wide Midfielder',
  'playerroles.DETERMINED_WIDE_MIDFIELDER': 'Determined Wide Midfielder',
  'playerroles.HEROIC_WIDE_MIDFIELDER': 'Heroic Wide Midfielder',
  'playerroles.ECCENTRIC_WIDE_MIDFIELDER': 'Eccentric Wide Midfielder',
  'playerroles.RELIABLE_WIDE_MIDFIELDER': 'Reliable Wide Midfielder',
  'playerroles.LUCKY_WIDE_MIDFIELDER': 'Lucky Wide Midfielder',
  'playerroles.TENACIOUS_WIDE_MIDFIELDER': 'Tenacious Wide Midfielder',
  'playerroles.INSPIRATIONAL_WIDE_MIDFIELDER': 'Inspirational Wide Midfielder',
  'playerroles.DOMINANT_WIDE_MIDFIELDER': 'Dominant Wide Midfielder',
  'playerroles.IMPACT_WIDE_MIDFIELDER': 'Impact Wide Midfielder',
  'playerroles.PRESSING_WIDE_MIDFIELDER': 'Pressing Wide Midfielder',
  'playerroles.STUBBORN_WIDE_MIDFIELDER': 'Stubborn Wide Midfielder',
  'playerroles.VOCAL_WIDE_MIDFIELDER': 'Vocal Wide Midfielder',
  'playerroles.EXPERIENCED_WIDE_MIDFIELDER': 'Experienced Wide Midfielder',
  'playerroles.PLAYMAKING_WIDE_MIDFIELDER': 'Playmaking Wide Midfielder',
  'playerroles.SHIELDING_WIDE_MIDFIELDER': 'Shielding Wide Midfielder',
  'playerroles.ORCHESTRATING_WIDE_MIDFIELDER': 'Orchestrating Wide Midfielder',
  'playerroles.SILKY_WIDE_MIDFIELDER': 'Silky Wide Midfielder',
  'playerroles.STAR_WIDE_MIDFIELDER': 'Star Wide Midfielder',
  'playerroles.BOX_TO_BOX_WIDE_MIDFIELDER': 'Box To Box Wide Midfielder',
  'playerroles.ATHLETIC_WIDE_MIDFIELDER': 'Athletic Wide Midfielder',
  'playerroles.ENERGETIC_WIDE_MIDFIELDER': 'Energetic Wide Midfielder',
  'playerroles.VALIANT_WIDE_MIDFIELDER': 'Valiant Wide Midfielder',
  'playerroles.PLUCKY_WIDE_MIDFIELDER': 'Plucky Wide Midfielder',
  'playerroles.ROBUST_WIDE_MIDFIELDER': 'Robust Wide Midfielder',
  'playerroles.AGGRESSIVE_WIDE_MIDFIELDER': 'Aggressive Wide Midfielder',
  'playerroles.GEGENPRESSING_WIDE_MIDFIELDER': 'Gegenpressing Wide Midfielder',
  'playerroles.COMMANDING_WIDE_MIDFIELDER': 'Commanding Wide Midfielder',
  'playerroles.WORKHORSE': 'Workhorse',
  'playerroles.CLASSIC_WIDE_MIDFIELDER': 'Classic Wide Midfielder',
  'playerroles.DEFENSIVE_WIDE_MAN': 'Defensive Wide Man',
  'playerroles.SUPPORTING_FLANKER': 'Supporting Flanker',
  'playerroles.FIREY_WIDE_MIDFIELDER': 'Firey Wide Midfielder',
  'playerroles.VERSATILE_WIDE_MIDFIELDER': 'Versatile Wide Midfielder',
  'playerroles.POWER_RUNNER': 'Power Runner',
  'playerroles.ROUSING_WIDE_MIDFIELDER': 'Rousing Wide Midfielder',

  // --- Central Midfielder Expanded Roles ---
  'playerroles.RAPID_CENTRAL_MIDFIELDER': 'Rapid Central Midfielder',
  'playerroles.POWERFUL_CENTRAL_MIDFIELDER': 'Powerful Central Midfielder',
  'playerroles.TIRELESS_CENTRAL_MIDFIELDER': 'Tireless Central Midfielder',
  'playerroles.DETERMINED_CENTRAL_MIDFIELDER': 'Determined Central Midfielder',
  'playerroles.HEROIC_CENTRAL_MIDFIELDER': 'Heroic Central Midfielder',
  'playerroles.ECCENTRIC_CENTRAL_MIDFIELDER': 'Eccentric Central Midfielder',
  'playerroles.RELIABLE_CENTRAL_MIDFIELDER': 'Reliable Central Midfielder',
  'playerroles.LUCKY_CENTRAL_MIDFIELDER': 'Lucky Central Midfielder',
  'playerroles.TENACIOUS_CENTRAL_MIDFIELDER': 'Tenacious Central Midfielder',
  'playerroles.INSPIRATIONAL_CENTRAL_MIDFIELDER':
    'Inspirational Central Midfielder',
  'playerroles.DOMINANT_CENTRAL_MIDFIELDER': 'Dominant Central Midfielder',
  'playerroles.IMPACT_CENTRAL_MIDFIELDER': 'Impact Central Midfielder',
  'playerroles.PRESSING_CENTRAL_MIDFIELDER': 'Pressing Central Midfielder',
  'playerroles.STUBBORN_CENTRAL_MIDFIELDER': 'Stubborn Central Midfielder',
  'playerroles.VOCAL_CENTRAL_MIDFIELDER': 'Vocal Central Midfielder',
  'playerroles.EXPERIENCED_CENTRAL_MIDFIELDER':
    'Experienced Central Midfielder',
  'playerroles.BOX_TO_BOX_MIDFIELDER': 'Box To Box Midfielder',
  'playerroles.TIKI_TAKA_MIDFIELDER': 'Tiki Taka Midfielder',
  'playerroles.PLAYMAKER': 'Playmaker',
  'playerroles.SHIELDING_MIDFIELDER': 'Shielding Midfielder',
  'playerroles.STAR_CENTRAL_MIDFIELDER': 'Star Central Midfielder',
  'playerroles.SILKY_CENTRAL_MIDFIELDER': 'Silky Central Midfielder',
  'playerroles.LETHAL_CENTRAL_MIDFIELDER': 'Lethal Central Midfielder',
  'playerroles.ROAMING_MIDFIELDER': 'Roaming Midfielder',
  'playerroles.ORCHESTRATING_MIDFIELDER': 'Orchestrating Midfielder',
  'playerroles.ATHLETIC_CENTRAL_MIDFIELDER': 'Athletic Central Midfielder',
  'playerroles.ENERGETIC_CENTRAL_MIDFIELDER': 'Energetic Central Midfielder',
  'playerroles.VALIANT_CENTRAL_MIDFIELDER': 'Valiant Central Midfielder',
  'playerroles.PLUCKY_CENTRAL_MIDFIELDER': 'Plucky Central Midfielder',
  'playerroles.ROBUST_MIDFIELDER': 'Robust Midfielder',
  'playerroles.GEGENPRESSING_MIDFIELDER': 'Gegenpressing Midfielder',
  'playerroles.COMMANDING_CENTRAL_MIDFIELDER': 'Commanding Central Midfielder',
  'playerroles.COMPLETE_MIDFIELDER': 'Complete Midfielder',
  'playerroles.MEZZALA': 'Mezzala',
  'playerroles.MIDFIELD_GENERAL': 'Midfield General',
  'playerroles.CAPTAIN_FANTASTIC': 'Captain Fantastic',
  'playerroles.CARRIER': 'Carrier',
  'playerroles.ENGINE': 'Engine',
  'playerroles.CARRILERO': 'Carrilero',
  'playerroles.ROUSING_CENTRAL_MIDFIELDER': 'Rousing Central Midfielder',
  'playerroles.FIREY_CENTRAL_MIDFIELDER': 'Firey Central Midfielder',
  'playerroles.VERSATILE_CENTRAL_MIDFIELDER': 'Versatile Central Midfielder',

  // --- Attacking Midfielder Expanded Roles ---
  'playerroles.RAPID_ATTACKING_MIDFIELDER': 'Rapid Attacking Midfielder',
  'playerroles.POWERFUL_ATTACKING_MIDFIELDER': 'Powerful Attacking Midfielder',
  'playerroles.TIRELESS_ATTACKING_MIDFIELDER': 'Tireless Attacking Midfielder',
  'playerroles.DETERMINED_ATTACKING_MIDFIELDER':
    'Determined Attacking Midfielder',
  'playerroles.HEROIC_ATTACKING_MIDFIELDER': 'Heroic Attacking Midfielder',
  'playerroles.ECCENTRIC_ATTACKING_MIDFIELDER':
    'Eccentric Attacking Midfielder',
  'playerroles.RELIABLE_ATTACKING_MIDFIELDER': 'Reliable Attacking Midfielder',
  'playerroles.LUCKY_ATTACKING_MIDFIELDER': 'Lucky Attacking Midfielder',
  'playerroles.STUBBORN_ATTACKING_MIDFIELDER': 'Stubborn Attacking Midfielder',
  'playerroles.TENACIOUS_ATTACKING_MIDFIELDER':
    'Tenacious Attacking Midfielder',
  'playerroles.INSPIRATIONAL_ATTACKING_MIDFIELDER':
    'Inspirational Attacking Midfielder',
  'playerroles.DOMINANT_ATTACKING_MIDFIELDER': 'Dominant Attacking Midfielder',
  'playerroles.IMPACT_ATTACKING_MIDFIELDER': 'Impact Attacking Midfielder',
  'playerroles.PRESSING_ATTACKER': 'Pressing Attacker',
  'playerroles.EXPERIENCED_ATTACKING_MIDFIELDER':
    'Experienced Attacking Midfielder',
  'playerroles.STAR_ATTACKING_MIDFIELDER': 'Star Attacking Midfielder',
  'playerroles.SILKY_ATTACKING_MIDFIELDER': 'Silky Attacking Midfielder',
  'playerroles.LETHAL_ATTACKING_MIDFIELDER': 'Lethal Attacking Midfielder',
  'playerroles.PENETRATING_ATTACKING_MIDFIELDER':
    'Penetrating Attacking Midfielder',
  'playerroles.PROLIFIC_ATTACKING_MIDFIELDER': 'Prolific Attacking Midfielder',
  'playerroles.VOCAL_ATTACKING_MIDFIELDER': 'Vocal Attacking Midfielder',
  'playerroles.ROAMING_ATTACKING_MIDFIELDER': 'Roaming Attacking Midfielder',
  'playerroles.ORCHESTRATING_ATTACKING_MIDFIELDER':
    'Orchestrating Attacking Midfielder',
  'playerroles.ADVANCED_PLAYMAKER': 'Advanced Playmaker',
  'playerroles.ATTACKING_OUTLET': 'Attacking Outlet',
  'playerroles.ENERGETIC_ATTACKING_MIDFIELDER':
    'Energetic Attacking Midfielder',
  'playerroles.ATHLETIC_ATTACKING_MIDFIELDER': 'Athletic Attacking Midfielder',
  'playerroles.PLUCKY_ATTACKING_MIDFIELDER': 'Plucky Attacking Midfielder',
  'playerroles.VALIANT_ATTACKING_MIDFIELDER': 'Valiant Attacking Midfielder',
  'playerroles.GEGEN_PRESSING_ATTACKER': 'Gegen Pressing Attacker',
  'playerroles.ARTIST': 'Artist',
  'playerroles.MAESTRO': 'Maestro',
  'playerroles.CATALYST': 'Catalyst',
  'playerroles.ENGANCHE': 'Enganche',
  'playerroles.TREQUARTISTA': 'Trequartista',
  'playerroles.LUXURY_PLAYER': 'Luxury Player',
  'playerroles.FIREY_ATTACKING_MIDFIELDER': 'Firey Attacking Midfielder',
  'playerroles.VERSATILE_ATTACKING_MIDFIELDER':
    'Versatile Attacking Midfielder',
  'playerroles.ROUSING_ATTACKER': 'Rousing Attacker',

  // --- Winger Expanded Roles ---
  'playerroles.RAPID_WINGER': 'Rapid Winger',
  'playerroles.POWERFUL_WINGER': 'Powerful Winger',
  'playerroles.TIRELESS_WINGER': 'Tireless Winger',
  'playerroles.DETERMINED_WINGER': 'Determined Winger',
  'playerroles.HEROIC_WINGER': 'Heroic Winger',
  'playerroles.ECCENTRIC_WINGER': 'Eccentric Winger',
  'playerroles.RELIABLE_WINGER': 'Reliable Winger',
  'playerroles.LUCKY_WINGER': 'Lucky Winger',
  'playerroles.TENACIOUS_WINGER': 'Tenacious Winger',
  'playerroles.INSPIRATIONAL_WINGER': 'Inspirational Winger',
  'playerroles.DOMINANT_WINGER': 'Dominant Winger',
  'playerroles.IMPACT_WINGER': 'Impact Winger',
  'playerroles.PRESSING_WINGER': 'Pressing Winger',
  'playerroles.VOCAL_WINGER': 'Vocal Winger',
  'playerroles.EXPERIENCED_WINGER': 'Experienced Winger',
  'playerroles.STAR_WINGER': 'Star Winger',
  'playerroles.SILKY_WINGER': 'Silky Winger',
  'playerroles.PENETRATING_WINGER': 'Penetrating Winger',
  'playerroles.PLAYMAKING_WINGER': 'Playmaking Winger',
  'playerroles.LETHAL_WINGER': 'Lethal Winger',
  'playerroles.ROAMING_WINGER': 'Roaming Winger',
  'playerroles.ORCHESTRATING_WINGER': 'Orchestrating Winger',
  'playerroles.WIDE_OUTLET': 'Wide Outlet',
  'playerroles.ATHLETIC_WINGER': 'Athletic Winger',
  'playerroles.ENERGETIC_WINGER': 'Energetic Winger',
  'playerroles.VALIANT_WINGER': 'Valiant Winger',
  'playerroles.PLUCKY_WINGER': 'Plucky Winger',
  'playerroles.GEGEN_PRESSING_WINGER': 'Gegen Pressing Winger',
  'playerroles.COMMANDING_WINGER': 'Commanding Winger',
  'playerroles.INSIDE_FORWARD': 'Inside Forward',
  'playerroles.CLASSIC_WINGER': 'Classic Winger',
  'playerroles.CREATIVE_WINGER': 'Creative Winger',
  'playerroles.FLYING_WINGER': 'Flying Winger',
  'playerroles.INVERTED_PLAYMAKER': 'Inverted Playmaker',
  'playerroles.ELUSIVE_WINGER': 'Elusive Winger',
  'playerroles.ROUSING_WINGER': 'Rousing Winger',
  'playerroles.FIREY_WINGER': 'Firey Winger',
  'playerroles.VERSATILE_WINGER': 'Versatile Winger',

  // --- Striker Expanded Roles ---
  'playerroles.RAPID_STRIKER': 'Rapid Striker',
  'playerroles.POWERFUL_STRIKER': 'Powerful Striker',
  'playerroles.TIRELESS_STRIKER': 'Tireless Striker',
  'playerroles.DETERMINED_STRIKER': 'Determined Striker',
  'playerroles.HEROIC_STRIKER': 'Heroic Striker',
  'playerroles.ECCENTRIC_STRIKER': 'Eccentric Striker',
  'playerroles.RELIABLE_STRIKER': 'Reliable Striker',
  'playerroles.LUCKY_STRIKER': 'Lucky Striker',
  'playerroles.TENACIOUS_STRIKER': 'Tenacious Striker',
  'playerroles.INSPIRATIONAL_STRIKER': 'Inspirational Striker',
  'playerroles.DOMINANT_STRIKER': 'Dominant Striker',
  'playerroles.IMPACT_STRIKER': 'Impact Striker',
  'playerroles.PRESSING_FORWARD': 'Pressing Forward',
  'playerroles.VOCAL_STRIKER': 'Vocal Striker',
  'playerroles.EXPERIENCED_STRIKER': 'Experienced Striker',
  'playerroles.STAR_STRIKER': 'Star Striker',
  'playerroles.SILKY_STRIKER': 'Silky Striker',
  'playerroles.LETHAL_STRIKER': 'Lethal Striker',
  'playerroles.PROLIFIC_STRIKER': 'Prolific Striker',
  'playerroles.FINESSE_STRIKER': 'Finesse Striker',
  'playerroles.PENETRATING_STRIKER': 'Penetrating Striker',
  'playerroles.OUTLET_FORWARD': 'Outlet Forward',
  'playerroles.PLAYMAKING_FORWARD': 'Playmaking Forward',
  'playerroles.ROAMING_FORWARD': 'Roaming Forward',
  'playerroles.ORCHESTRATING_FORWARD': 'Orchestrating Forward',
  'playerroles.ATHLETIC_STRIKER': 'Athletic Striker',
  'playerroles.ENERGETIC_STRIKER': 'Energetic Striker',
  'playerroles.VALIANT_STRIKER': 'Valiant Striker',
  'playerroles.PLUCKY_STRIKER': 'Plucky Striker',
  'playerroles.GEGEN_PRESSING_FORWARD': 'Gegen Pressing Forward',
  'playerroles.COMMANDING_STRIKER': 'Commanding Striker',
  'playerroles.POACHER': 'Poacher',
  'playerroles.ADVANCED_FORWARD': 'Advanced Forward',
  'playerroles.TRICKY_FINISHER': 'Tricky Finisher',
  'playerroles.DOMINANT_TARGET_MAN': 'Dominant Target Man',
  'playerroles.DEEP_LYING_FORWARD': 'Deep Lying Forward',
  'playerroles.COMPLETE_FORWARD': 'Complete Forward',
  'playerroles.ASSASSIN': 'Assassin',
  'playerroles.OLD_FASHIONED_NUMBER_NINE': 'Old Fashioned Number Nine',
  'playerroles.HOLD_UP_SPECIALIST': 'Hold Up Specialist',
  'playerroles.FALSE_NINE': 'False Nine',
  'playerroles.TARGET_MAN': 'Target Man',
  'playerroles.PREDATOR': 'Predator',
  'playerroles.TAP_IN_MERCHANT': 'Tap In Merchant',
  'playerroles.FIREY_STRIKER': 'Firey Striker',
  'playerroles.VERSATILE_STRIKER': 'Versatile Striker',
  'playerroles.LETHAL_GOAL_MACHINE': 'Lethal Goal Machine',
  'playerroles.RAUMDAUTER': 'Raumdeuter',
  'playerroles.ROUSING_STRIKER': 'Rousing Striker',
  'playerroles.HOT_SHOT': 'Hot Shot',
};
